import { render } from "./index-edit.vue?vue&type=template&id=30cd5bb6&scoped=true"
import script from "./index-edit.vue?vue&type=script&lang=js"
export * from "./index-edit.vue?vue&type=script&lang=js"

import "./index-edit.vue?vue&type=style&index=0&id=30cd5bb6&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cd5bb6"]])

export default __exports__